/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { LoadingSpinner } from '@blend/enterprise-components';
import { Text } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import { enterpriseColors } from '../../../../src/style/colors';

export namespace EmptySection {
  export interface Props {
    isLoading: boolean;
    isEmpty: boolean;
    emptyMessage: string;
  }
}

export const styles = StyleSheet.create({
  wrapper: {
    color: enterpriseColors.NEUTRAL_800,
    padding: '20px 20px',
    maxWidth: 1400,
    border: `1px solid ${enterpriseColors.NEUTRAL_200}`,
    borderRadius: 6,
    backgroundColor: enterpriseColors.WHITE,
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  centeredContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    padding: '12px',
  },
});

export const EmptySection: React.FC<EmptySection.Props> = ({ isLoading, isEmpty, emptyMessage }) => {
  if (isLoading) {
    return (
      <div className={css(styles.centeredContainer)}>
        <LoadingSpinner size="lg" theme="secondary" />
      </div>
    );
  }
  if (isEmpty) {
    return (
      <div data-it="it-emptyMessage" className={css(styles.wrapper)}>
        <Text>{emptyMessage}</Text>
      </div>
    );
  }
  return null;
};
